import styled from 'styled-components';
import { Box } from 'vqp-common';
import { Button } from '../../components/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.textBold};
`;
export const SubTitle = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-weight: 700;
    width: 100%;

    > div{
        cursor: pointer;
        margin-right: 2rem;
        color: ${(props) => props.theme.colors.textBold};

        &.selected{
            color: ${(props) => props.theme.colors.primary}
            border-bottom: 2px solid;
            padding-bottom: 5px;
        }
    }
`;
export const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`;
export const CardDay = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid ${(props) => props.theme.colors.lineGrey};
  width: 100%;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Div = styled.div`
  display: flex;
  flex-direction: column;

  &.exception {
    width: 100%;
  }
`;
export const HourWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
`;
export const HourWrapperExceptions = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Hour = styled.div`
  display: flex;
  flex-direction: row;
  background: ${(props) => props.theme.colors.lightBlue};
  margin: 10px 0 10px 8px;
  padding: 8px;
  border-radius: 10px;
  align-items: center;
  font-weight: 700;

  &.disabled {
    opacity: 0.6;
    background: ${(props) => props.theme.colors.opacityBlue};
  }

  &.exception {
    justify-content: space-between;
  }
`;
export const DivButton = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0 10px 8px;
  padding: 8px;
  border-radius: 10px;
  align-items: center;
`;
export const DivButtonSave = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 10px 8px;
  padding: 8px;
  border-radius: 10px;
  align-items: center;
`;
export const SpanTitle = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-size: 11px;
  font-weigth: 400;
  margin: 0 5px;
`;
export const Span = styled.span`
  color: ${(props) => props.theme.colors.textBold};
  font-size: 11px;
  margin: 0 5px;
`;
export const DivTitle = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ButtonClose = styled.div`
  width: 30px;
  height: 30px;
`;
export const H3 = styled.h3`
  font-size: 13px;
  font-weigth: bold;
  margin: 1rem 0;
  color: ${(props) => props.theme.colors.primary};
`;
export const H4 = styled.h4`
  font-size: 12px;
  font-weigth: bold;
  color: ${(props) => props.theme.colors.primary};
  margin: 0 1rem 0 0;
`;
export const Col1 = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  margin: 20px;
`;
export const FieldWrapper = styled.div`
  // width: 100%;
  // max-width:100px;
`;

export const DateFieldWrapper = styled.div`
  margin: 0 0 -16px 0;

  input {
    height: 26px;
  }
`;

export const NewProductButton = styled(Button)`
  margin-left: auto;
`;
export const SaveButton = styled(Button)``;
export const CheckboxWrapper = styled.div`
  font-size: 12px;
  padding-left: 6px;
`;

export const ErrorMessage = styled.div`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.textBold};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const ErrorMessageTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
`;

export const ErrorMessageSubtitle = styled.span`
  font-size: 1rem;
  max-width: 40rem;
  text-align: center;
`;
